<template>
    <section class="recent-wrapper">
        <div class="container">
            <div class="withdraw-sec">

                <AddBankAccount :bankList="bankList" v-if="type == 'bank' "
                    :bankDetails="bankDetails"
                    @forget-withdraw-password="forgetWithdrawPassword"
                    />
                <AddUpiAccount :upiDetails="upiDetails"  v-else
                    @forget-withdraw-password="forgetWithdrawPassword"
                    :paymentMethod="paymentMethod"
                    />

                <div class="back_btn_cl">
                    <button @click="addAccount()" type="button" class="thm-but back_btn_link withdraw_btn_cl" id="account-successfully">{{$t('continue-to-add-account','Continue to add account')}}</button>
                </div>
            </div>
        </div>
    </section>

      <!-- <section class="withdraw-fix p-gap-35">
         <div class="container">
            <div class="withdraw-fix-sec continue-btn">
               <a @click="addAccount()" href="javascript:void(0);" class="thm-but back_btn_link" id="account-successfully">{{$t('continue-to-add-account','Continue to add account')}}</a>
            </div>
         </div>
      </section> -->

    <WithdrawPasswordModal ref="withdrawSetReset"
        :triggerAddAccountMethod="triggerAddAccountMethod"
    />
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';
import { addAccount, openWithdrawPasswordModal} from "@template/utils"
import AddBankAccount from '../components/AddBankAccount.vue';
import AddUpiAccount from '../components/AddUpiAccount.vue';
import WithdrawPasswordModal from '../components/WithdrawPasswordModal.vue';
export default {
    name: 'WithdrawAccountDetails',
    setup() {
		return { v$: useVuelidate() }
	},
    components: {
		AddBankAccount,
        AddUpiAccount,
		WithdrawPasswordModal
    },
    data(){
        return{
            bankList: null,
            s3Url: null,
            type: null,
            bankDetails:{
                method_id: null,
                account_holder_name: null,
                account_no: null,
                ifsc_code: null,
                withdrawal_password: null,
            },
            upiDetails:{
                account_holder_name: null,
                upi_id: null,
                // phone_no: null,
                qr_code: null,
                withdrawal_password: null,
            },
        }
    },
    computed:{
        ...mapGetters(['paymentMethod'])
    },
    mounted(){
        this.type = this.$route.params?.type
        let paymentId = Number(this.$route.params?.id)
        this.upiDetails.method_id = paymentId
    },
    methods:{
        forgetWithdrawPassword(){
            this.openWithdrawPasswordModal();
        },
        async addAccount(){
            this.v$.$touch();
			if (this.v$.$error) {
				// this.$errorToast('Please fill the required fields');
				return;
			}
            if(this.type === 'upi' && !this.upiDetails.upi_id && this.upiDetails.qr_code == null){
                this.$errorToast('At least one field is required UPI ID or QR code.')
                return false;
            }
            let response = await addAccount(this.paymentMethod, this.type, this.bankDetails, this.upiDetails)
            if(response){
                this.$router.push({
                    name:'WithdrawDetails'
                })
            }
        },
        triggerAddAccountMethod(){
            this.addAccount();
        },
        async openWithdrawPasswordModal(){
            let response = await openWithdrawPasswordModal()
            if(!response?.error){
                this.$helper.openModal('#newUserWithDrawPasswordModel');
                this.$refs.withdrawSetReset.otpHasBeenCalled()
                this.$refs.withdrawSetReset.resetTimer();
            }else{
                // this.addAccount();
                this.$errorToast(response?.error);
            }

        }
    }
}
</script>